<template>
  <modal
    name="add-vehicle-modal"
    :height="isMobile ? '100%' : '100%'"
    :width="isMobile ? '100%' : '60%'"
    @closed="$emit('refresh')"
  >
    <div
      class="pt-3 pb-2 pr-4 pl-4 border-gray-100 dark:border-gray-500 dark:bg-gray-900 dark:text-gray-200"
    >
      <h4 class="inline-block w-11/12">LİSTEYE YENİ ARAÇ EKLE </h4>
      <button class="p-2 w-1/12" @click="$modal.hide('add-vehicle-modal')">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="h-auto py-4 mx-4">
      <div class="flex">
        <div class="w-1/3">
          <diffInput
          type="numberLength"
          v-model="recomendedVehicleCount"
          :required="true"
          title="Araç Sayısı"
          :min="0"
          :valCount="calculateMaxVehicleCount()"
        />
        </div>
         <div class="w-1/3 ml-4">
            <diffInput
                type="select"
                :optList="[
                  {
                    id: 3,
                    name: 'Hepsi',
                  },
                  {
                    id: 1,
                    name: 'Kiralık',
                  },
                  {
                    id: 2,
                    name: 'Özmal',
                  },
                ]"
                minlength="1"
                :required="true"
                v-model="haveType"
                title="Araç Türü"
            />  
         </div>
       
      </div>

      <bulkVehicle
        class=""
        :totalCount="recomendedVehicleCount"
        @removeVehicle="
          () => (recomendedVehicleCount = Number(recomendedVehicleCount) - 1)
        "
        @addVehicle="
          () => (recomendedVehicleCount = Number(recomendedVehicleCount) + 1)
        "
        @change="(r) => (vehiclesToWork = r)"
        :recomendedCount="orderItem.recomendedCount"
        :deliveryDate="orderItem.complateDate"
        :center="calculateCenter()"
        :order="orderItem"
        :hiddenInsert="false"
        :rowId="rowId"
        network="ship"
        :isLoading="load"
        :haveType="haveType"
      />
      <div class="w-full mt-4 text-right">
        <asyncBtn
          icon="fas fa-check"
          :text="$t('general.saveButtonTitle')"
          :loadTitle="$t('general.saveButtonLoadTitle')"
          :loadState="load"
          class="w-full"
          @click="bulkSave()"
          :disabled="!vehiclesToWork.length || load"
        />
      </div>
    </div>
  </modal>
</template>

<script>
// import vehicleInputVue from "./../../../orders/components/vehicle-select.vue";
// import orderInput from "../../../../../components/devItem/orderInput.vue";

//Global Components
import diffInput from "@/components/general/diffInput.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";
import bulkVehicle from "@/components/general/vehicleTable/vehicles.vue";


//Axios
import { bulkShipPlanning } from "@/networking/urlmanager";
import { getLocationAll } from "@/utils/detailData";
import axios from "axios";


export default {
  props: [
    "rowId",
    "orderNo",
    "capacity",
    "customerList",
    "customers",
    "orderItem",
    "totalRemainingTonnage",
  ],
  components: {
    // vehicleInputVue,
    diffInput,
    asyncBtn,
    bulkVehicle,
  },
  data() {
    return {
      // dorseName: "",
      load: false,
      vehicleList: [],
      recomendedVehicleCount: "",
      vehicleLoad: false,
      vehicle: "",
      driverName: "",
      driverTC: "",
      longitude: "",
      latitude: "",
      haveType: 3,
      vehiclesToWork: [],
    };
  },
  methods: {
    calculateMaxVehicleCount() {
      const total = Number(this.totalRemainingTonnage || 0);
      return total > 0 ? Math.ceil(total / 26) : 0;
    },  
    calculateCenter() {
      if (!this.orderItem) {
        return { lat: 0, lng: 0 };
      }
      return {
        lat:
          (this.orderItem.fillingLatitude + this.orderItem.deliveryLatitude) /
          2,
        lng:
          (this.orderItem.fillingLongitude + this.orderItem.deliveryLongitude) /
          2,
      };
    },
    bulkSave() {
      const invalidVehicles = this.vehicleList?.filter((item) => {
        return !(item.driverName && item.driverTC);
      });

      if (invalidVehicles?.length > 0) {
        const vehicles = invalidVehicles.map((item) => item.vehicle).join(", ");
        this.swalBox(
          "warning",
          "Uyarı!",
          `Planlama yapılamaz !!! Aşağıdaki ${
            invalidVehicles.length > 1 ? "araçlar" : "araç"
          } için sürücü bilgisi veya TC kimlik bilgisi eksik:${vehicles} Plakalı ${
            invalidVehicles.length > 1 ? "araçlara" : "araca"
          } Lütfen sürücü atayınız veya mevcut sürücünün TC kimlik bilgisini giriniz.`
        );
        return;
      }

      this.load = true;
      axios
        .post(
          bulkShipPlanning.vehicleAdd,
          {
            shipId: this.rowId,
            vehicleList: this.vehiclesToWork.map((item) => {
              return {
                vehicle: item.vehicle,
                plate: item.vehicle,
                dorse: item.dorse,
                driverName: item.driverName,
                isCustom: item.isCustom ?? 1,
                driverTC: item.driverTC,
                capacity: item.capacity,
                longitude: item.longitude,
                latitude: item.latitude,
                isWashing: item.recomendation?.isWashing || 3,
              };
            }),
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(() => {
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          );
          this.$modal.hide("add-vehicle-modal");
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },
  },
  computed: {
    getFilterVehicle() {
      return this.vehicleList.map((item) => {
        return {
          name: item.vehicle,
          id: item.id,
          driverName: item.driverName,
          dorse: item.dorse,
          capacity: item.capacity,
          longitude: item.longitude,
          latitude: item.latitude,
          orderNos: item.orderNos, //ORDERNOS EKLENDİ
        };
      });
    },
  },
  async created() {
    this.vehicleLoad = true;
    this.vehicleList = await getLocationAll(this.$store.state.userData.token);

    // console.log("araçlar:01ANL620:",this.vehicleList.filter(z=>z.plate=='01ANL620'));
    this.vehicleLoad = false;
  },
};
</script>
